<div class="popupsec" id="popupsec">
  <a (click)="closeDialog()" class="md-dialog-close waves-effect closebtncls"><i class="material-icons btn-floating btn-small waves-effect waves-light cross-icon-bg"></i></a>
  <div id="contentSec">

    <md-dialog-content>

      <div class="selectCheckBoxSec row">
        <span class="col s2 l2 m2">BLACKLIST EXAM</span>
        <div class="col">
          <md-checkbox [(ngModel)]="doAllExamisBlacklisted" (change)="onSelectAll($event.checked)">Select All</md-checkbox>
          <md-checkbox [(ngModel)]="undoAllExamisBlacklisted" (change)="onUnSelectAll($event.checked)">Unselect All</md-checkbox>
        </div>
      </div>
      <div class="selectAlphabeticLetterSec">
        <span *ngFor="let item of alphabets;" (click)="selectedChar = item;">
          <span [ngClass]="{'active-char': (selectedChar == item) }">{{item}}</span>
        </span>
      </div>
      <div class="exam-item">
        <div class="row">
          <div class="glossaryListSec">
            <div *ngFor="let item of formattedExamData;">
              <div *ngIf="selectedChar == '#' || item.label == selectedChar">
                <div class="listAlphabetic">
                  <p class="label">{{item.label}}</p>
                  <div *ngFor="let subItem of item.data;">
                    <md-checkbox [(ngModel)]="subItem.isBlacklisted">{{subItem.examName}}</md-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="button-row popupBtnCls">
        <button md-raised-button class="glbAdminBtnCls1" (click)="onUpdate()">UPDATE</button>
      </div>
    </md-dialog-content>
  </div>
</div>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-location-setting/adm-blacklist-exam/adm-blacklist-exam.component.html